import priceUpdateList from './priceUpdateList';
import priceUpdateEdit from './priceUpdateEdit';
import priceUpdateUpload from './priceUpdateUpload';

export default {
    list: priceUpdateList,
    edit: priceUpdateEdit,
    create: priceUpdateUpload,
}